module.exports = __webpack_public_path__ + "img/copy-icon.fe2e9751.svg";